import { companyActions } from "./company-slice";

export const GetCompanies = (email) => {
  return async (dispatch) => {
    const GetCompaniesInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/company/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetCompaniesInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          companyActions.setCompanies({
            
            
            companies: response.data.map((company) => {
              return {
                ...company,
                status: company.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          companyActions.setCompanies({
            statues: [],
          })
        );
      }
    } catch (error) {}
  };
};
